<template>
  <WebTop />
  <div id="body-wrap">
  <Row :gutter="22">
      <Col span="14">
        <div class="home-block-title">
          <Icon type="ios-book-outline" color="#2d8cf0" /> <b style="color: #2d8cf0">典型案例</b>
        </div>
        <Carousel dots="none" autoplay="true" autoplay-speed="5000" loop>
          <CarouselItem>
            <div class="home-carousel">
              <img src="../../assets/images/p1.jpg">
              <div class="carousel-title"><router-link :to="{path: '/article/show', query: {id: 863806559650368}}">典型案例 | 盗卖他人“剧本杀” 构成侵权被判罚</router-link></div>
            </div>
          </CarouselItem>
          <CarouselItem>
            <div class="home-carousel">
              <img src="../../assets/images/p2.jpg" />
              <div class="carousel-title"><router-link :to="{path: '/question/show', query: {id: 863808419684928}}">维权调研丨诚邀您参加“青年文艺工作者维权需求调查问卷”</router-link></div>
            </div>
          </CarouselItem>
          <CarouselItem>
            <div class="home-carousel">
              <img src="../../assets/images/p3.jpg" />
              <div class="carousel-title"><router-link :to="{path: '/question/show', query: {id: 863803897913920}}">文艺相关行业复苏助力中国版权产业经济增长</router-link></div>
            </div>
          </CarouselItem>
          <!-- <CarouselItem>
            <div class="home-carousel">
              <img src="../../assets/images/p4.jpg" />
              <div class="carousel-title"><router-link :to="{path: '/question/show', query: {id: 813525419569792}}">什么时候开展海洋风主题歌曲的作品征集活动</router-link></div>
            </div>
          </CarouselItem> -->
        </Carousel>
      </Col>
      <Col span="10">
        <div class="home-block-title">
          <Icon type="ios-book-outline" color="#2d8cf0" /> <b style="color: #2d8cf0">工作简报</b>
        </div>
        <List>
            <ListItem v-for="(w, idx) in workBriefings" :key="idx">
                <!-- <ListItemMeta title="This is title" description="This is description, this is description." /> -->
                <ListItemMeta>
                  <template #title><router-link :to="{path: '/article/show', query: {id: w.id}}">{{ w.title }}</router-link></template>
                  <template #description>{{ w.createUserName }} 发表于 {{ w.createTime }}</template>
                </ListItemMeta>
            </ListItem>
             
        </List>
      </Col>
  </Row>
  <div class="home-block-title" style="margin-top: 24px;">
    <Icon type="ios-book-outline" color="#2d8cf0" /> <b style="color: #2d8cf0">维权咨询</b>
  </div>
  <List item-layout="vertical"  style="padding: 12px; border: solid 1px #dcdee2; border-top: none;">
    <ListItem v-for="item in questions" :key="item.id">
      <ListItemMeta>
        <template #title><router-link :to="{path: '/question/show', query: {id: item.id}}"><b>{{ item.title }}</b></router-link></template>
        <!-- <template #description>{{ item.forumDesc }}</template> -->
      </ListItemMeta>
      <!--最新帖子：{{item.content}}-->
      <template #action>
        <li>
          <Icon type="ios-chatbubbles-outline" /> 提问人 <b>{{ item.createUserName }}</b>
        </li>
        <li>
          <Icon type="ios-thumbs-up-outline" /> 发布日期 <b>{{ item.createTime }}</b>
        </li>
        <li>
          <Icon type="ios-chatbubbles-outline" /> 回复数量 <b>{{ item.answerNum }}</b>
        </li>
      </template>
    </ListItem>
  </List>


  
</div>

</template>
<script>
import WebTop from '../../components/WebTop.vue'
import global from '../../utils/global'
import axios from 'axios'
export default {
  components: {
    WebTop
  },
  data () {
    return {
      questions: [],
      workBriefings:[]
    }
  },
  mounted() {
    this.workBriefing()
    this.listQuestions()
  },
  methods: {
    workBriefing() {
      let vm = this
      axios({
        method: 'post',
        url: global.restUrl + '/api/web/article/v1.0/list',
        data: {
          categoryCode:"work_briefing",
          limit:4
        }
      }).then(function (response) {
        let success = response.data.success
        if(success) {
          let data = response.data.data
          vm.workBriefings = data.list
        }
      });
    },
    listQuestions() {
      let vm = this
      axios({
        method: 'post',
        url: global.restUrl + '/api/web/ask/v1.0/question/list',
        data: {
          categoryCode:"work_briefing",
          limit:6
        }
      }).then(function (response) {
        let success = response.data.success
        if(success) {
          let data = response.data.data
          vm.questions = data.list
        }
      });
    }
  }
}
</script>
